// App-wide overlays: the launcher sheet and the command palette.
import { defineStore } from "pinia";
import { ref } from "vue";

export interface LaunchPrefill {
  ticket?: string;
  flow?: string;
}

export const useUiStore = defineStore("ui", () => {
  const launchOpen = ref(false);
  const launchPrefill = ref<LaunchPrefill>({});
  const paletteOpen = ref(false);
  const railCollapsed = ref(false);

  function openLaunch(prefill: LaunchPrefill = {}): void {
    launchPrefill.value = prefill;
    paletteOpen.value = false;
    launchOpen.value = true;
  }

  return { launchOpen, launchPrefill, paletteOpen, railCollapsed, openLaunch };
});
